// src/lib/published-bounds.ts
//
// ★★ WAVE 8 (Task 3) — THE SERVER'S OWN BOUNDS, TURNED INTO WORDS AND INTO A
// FIELD-LEVEL PROBLEM. Nothing here invents a number.
//
// ══ WHAT THIS IS, AND WHAT MAKES IT NOT A SECOND COPY ══
//
// `ReferenceDataPage` has shown its real bounds since Wave 3 by reading
// `selectedRow.validation` — the catalogue's own block, published by
// `GET /api/reference`. Its header states the principle this file generalises:
// *"The client validates NOTHING the server does not."* Every other
// administration catalogue screen showed nothing, and the tempting fix —
// hand-typing each route's numbers into each screen — is **S-011**: a bound a
// screen invented is a second copy that drifts, silently, in the direction that
// makes the screen look right.
//
// So every function here takes a {@link PublishedFieldBounds} that arrived **in
// the payload** and does nothing but render or compare it. There is no literal
// bound in this file, no fallback, and no default — which is the property
// `published-bounds.test.ts` (the census) exists to keep true across all thirteen
// screens.
//
// ══ ⚠ ABSENCE IS A MEANING, NOT A GAP ══
//
// `undefined` bounds, and an absent property on a present bound, mean **the
// server enforces nothing on that axis** — because a route that enforces nothing
// beyond presence publishes nothing beyond presence. So:
//
//   · {@link boundsSentence} answers `null` rather than "no limit" or "any
//     length": the screen then says nothing, which is the honest output.
//   · {@link boundsProblem} answers `null` rather than guessing a ceiling.
//
// A `?? 200` anywhere in this file, or at any call site, would manufacture the
// defect the whole mechanism removes. There is deliberately no parameter that
// would let a caller supply one.
//
// ══ ⚠ WHY THE CHECK IS AGAINST THE VALUE THAT WILL BE **SENT** ══
//
// Several of these forms transform what was typed before submitting it —
// `code.trim().toUpperCase()` is the common one. The server's pattern applies to
// the TRANSFORMED value, so checking the raw keystrokes would refuse `b2` for
// failing `^[A-Z]...` when the route would have accepted the `B2` the screen was
// about to send. Callers therefore pass the value they will send, not the value
// in the box. This is also why the published `pattern` is NOT put on the input's
// `pattern` attribute: browser constraint validation runs on the raw value and
// blocks submission with no announcement — `e2e/write-forms.spec.ts`'s own header
// records a debugging session lost to exactly that silence.
import type { PublishedBounds, PublishedFieldBounds } from './types'

/**
 * A published pattern in the words an officer reads ("capital letters, digits and underscores"), never the pattern.
 * Understands the shapes the catalogues publish (`^[A-Z][A-Z0-9_]{0,19}// src/lib/published-bounds.ts
//
// ★★ WAVE 8 (Task 3) — THE SERVER'S OWN BOUNDS, TURNED INTO WORDS AND INTO A
// FIELD-LEVEL PROBLEM. Nothing here invents a number.
//
// ══ WHAT THIS IS, AND WHAT MAKES IT NOT A SECOND COPY ══
//
// `ReferenceDataPage` has shown its real bounds since Wave 3 by reading
// `selectedRow.validation` — the catalogue's own block, published by
// `GET /api/reference`. Its header states the principle this file generalises:
// *"The client validates NOTHING the server does not."* Every other
// administration catalogue screen showed nothing, and the tempting fix —
// hand-typing each route's numbers into each screen — is **S-011**: a bound a
// screen invented is a second copy that drifts, silently, in the direction that
// makes the screen look right.
//
// So every function here takes a {@link PublishedFieldBounds} that arrived **in
// the payload** and does nothing but render or compare it. There is no literal
// bound in this file, no fallback, and no default — which is the property
// `published-bounds.test.ts` (the census) exists to keep true across all thirteen
// screens.
//
// ══ ⚠ ABSENCE IS A MEANING, NOT A GAP ══
//
// `undefined` bounds, and an absent property on a present bound, mean **the
// server enforces nothing on that axis** — because a route that enforces nothing
// beyond presence publishes nothing beyond presence. So:
//
//   · {@link boundsSentence} answers `null` rather than "no limit" or "any
//     length": the screen then says nothing, which is the honest output.
//   · {@link boundsProblem} answers `null` rather than guessing a ceiling.
//
// A `?? 200` anywhere in this file, or at any call site, would manufacture the
// defect the whole mechanism removes. There is deliberately no parameter that
// would let a caller supply one.
//
// ══ ⚠ WHY THE CHECK IS AGAINST THE VALUE THAT WILL BE **SENT** ══
//
// Several of these forms transform what was typed before submitting it —
// `code.trim().toUpperCase()` is the common one. The server's pattern applies to
// the TRANSFORMED value, so checking the raw keystrokes would refuse `b2` for
// failing `^[A-Z]...` when the route would have accepted the `B2` the screen was
// about to send. Callers therefore pass the value they will send, not the value
// in the box. This is also why the published `pattern` is NOT put on the input's
// `pattern` attribute: browser constraint validation runs on the raw value and
// blocks submission with no announcement — `e2e/write-forms.spec.ts`'s own header
// records a debugging session lost to exactly that silence.
import type { PublishedBounds, PublishedFieldBounds } from './types'

, `^[A-Z_]+// src/lib/published-bounds.ts
//
// ★★ WAVE 8 (Task 3) — THE SERVER'S OWN BOUNDS, TURNED INTO WORDS AND INTO A
// FIELD-LEVEL PROBLEM. Nothing here invents a number.
//
// ══ WHAT THIS IS, AND WHAT MAKES IT NOT A SECOND COPY ══
//
// `ReferenceDataPage` has shown its real bounds since Wave 3 by reading
// `selectedRow.validation` — the catalogue's own block, published by
// `GET /api/reference`. Its header states the principle this file generalises:
// *"The client validates NOTHING the server does not."* Every other
// administration catalogue screen showed nothing, and the tempting fix —
// hand-typing each route's numbers into each screen — is **S-011**: a bound a
// screen invented is a second copy that drifts, silently, in the direction that
// makes the screen look right.
//
// So every function here takes a {@link PublishedFieldBounds} that arrived **in
// the payload** and does nothing but render or compare it. There is no literal
// bound in this file, no fallback, and no default — which is the property
// `published-bounds.test.ts` (the census) exists to keep true across all thirteen
// screens.
//
// ══ ⚠ ABSENCE IS A MEANING, NOT A GAP ══
//
// `undefined` bounds, and an absent property on a present bound, mean **the
// server enforces nothing on that axis** — because a route that enforces nothing
// beyond presence publishes nothing beyond presence. So:
//
//   · {@link boundsSentence} answers `null` rather than "no limit" or "any
//     length": the screen then says nothing, which is the honest output.
//   · {@link boundsProblem} answers `null` rather than guessing a ceiling.
//
// A `?? 200` anywhere in this file, or at any call site, would manufacture the
// defect the whole mechanism removes. There is deliberately no parameter that
// would let a caller supply one.
//
// ══ ⚠ WHY THE CHECK IS AGAINST THE VALUE THAT WILL BE **SENT** ══
//
// Several of these forms transform what was typed before submitting it —
// `code.trim().toUpperCase()` is the common one. The server's pattern applies to
// the TRANSFORMED value, so checking the raw keystrokes would refuse `b2` for
// failing `^[A-Z]...` when the route would have accepted the `B2` the screen was
// about to send. Callers therefore pass the value they will send, not the value
// in the box. This is also why the published `pattern` is NOT put on the input's
// `pattern` attribute: browser constraint validation runs on the raw value and
// blocks submission with no announcement — `e2e/write-forms.spec.ts`'s own header
// records a debugging session lost to exactly that silence.
import type { PublishedBounds, PublishedFieldBounds } from './types'

/**
 * A published pattern in the words an officer reads ("capital letters, digits and underscores"), never the expression.
 * It understands the shapes the catalogues publish (a first class, then an optional second class with a length); a shape
 * it does not understand answers `null`, and the caller says "the format the system accepts" instead.
 */
export function patternWords(pattern: string): string | null {
  const classWords = (cls: string): string[] | null => {
    const words: string[] = []
    let rest = cls
    const take = (re: RegExp, word: string): void => {
      if (re.test(rest)) {
        words.push(word)
        rest = rest.replace(re, '')
      }
    }
    take(/A-Z/, 'capital letters')
    take(/a-z/, 'lower-case letters')
    take(/0-9/, 'digits')
    take(/_/, 'underscores')
    take(/-/, 'hyphens')
    return rest === '' ? words : null
  }
  const m = /^\^\[([^\]]+)\](?:\[([^\]]+)\](?:\{\d+,\d+\}|\+|\*)?|\{\d+,\d+\}|\+|\*)?\$$/.exec(pattern)
  if (m === null) return null
  const first = classWords(m[1] ?? '')
  const second = m[2] === undefined ? [] : classWords(m[2])
  if (first === null || second === null) return null
  const all = [...new Set([...first, ...second])]
  if (all.length === 0) return null
  const list = all.length === 1 ? (all[0] as string) : `${all.slice(0, -1).join(', ')} and ${all[all.length - 1]}`
  return list.charAt(0).toUpperCase() + list.slice(1)
}

/**
 * The published bounds as one short sentence, or `null` when there is nothing the
 * server enforces to say.
 *
 * ⚠ Built from the numbers, never from a stored phrase: a sentence typed beside a
 * bound is the second copy again, one indirection further out.
 *
 * ⚠ **It has to stand as its own sentence, because it usually follows one.**
 * `BoundedField` renders the screen's example first ("e.g. A, B1, B2, C.") and this
 * after it, so the first draft produced *"e.g. A, B1, B2, C. matching
 * ^[A-Z][A-Z0-9]{0,7}$."* — read in a real browser, which is how it was caught.
 * Whichever clause comes FIRST therefore carries the capital and a verb; the ones
 * after it stay in the lower-case continuation form.
 */
export function boundsSentence(bounds: PublishedFieldBounds | undefined): string | null {
  if (bounds === undefined) return null
  const parts: string[] = []
  const { minLength, maxLength, pattern, min } = bounds
  if (minLength !== undefined && maxLength !== undefined) parts.push(`${minLength} to ${maxLength} characters`)
  else if (maxLength !== undefined) parts.push(`At most ${maxLength} characters`)
  else if (minLength !== undefined) parts.push(`At least ${minLength} characters`)
  if (pattern !== undefined) {
    // the pattern in words, first; the length follows it ("Capital letters and digits, up to 20 characters.")
    const words = patternWords(pattern) ?? 'Use the format the system accepts'
    const length = parts.length === 0 ? null : (parts[0] as string).replace(/^At most /, 'up to ').replace(/^At least /, 'at least ')
    parts.length = 0
    parts.push(length === null ? words : `${words}, ${length}`)
  }
  if (min !== undefined) parts.push(parts.length === 0 ? `Must be ${min} or greater` : `${min} or greater`)
  if (parts.length === 0) return null
  return `${parts.join(', ')}.`
}

/**
 * The field-level problem the published bounds imply for the value that will be
 * SENT, or `null` when there is none.
 *
 * ⚠ Blank answers `null`, for the reason `FieldError`'s own `wholeNumberProblem`
 * gives: an untouched field is not an invalid one, and `role="alert"` would
 * announce the accusation the moment the form opened. Emptiness is `required`'s
 * business.
 */
export function boundsProblem(sent: string, label: string, bounds: PublishedFieldBounds | undefined): string | null {
  if (bounds === undefined) return null
  if (sent.length === 0) return null
  const { minLength, maxLength, pattern, min } = bounds
  if (maxLength !== undefined && sent.length > maxLength) {
    return `${label} may be at most ${maxLength} characters; this one is ${sent.length}.`
  }
  if (minLength !== undefined && sent.length < minLength) {
    return `${label} must be at least ${minLength} characters.`
  }
  if (pattern !== undefined && !matchesPublishedPattern(pattern, sent)) {
    const words = patternWords(pattern)
    return words === null ? `${label} is not in the format the system accepts.` : `${label} may use only ${words.charAt(0).toLowerCase()}${words.slice(1)}${/^\^\[A-Z\]\[/.test(pattern) ? ', and must start with a capital letter' : ''}.`
  }
  if (min !== undefined) {
    const parsed = Number(sent)
    if (Number.isFinite(parsed) && parsed < min) return `${label} must be ${min} or greater.`
  }
  return null
}

/**
 * The published pattern, compiled and applied.
 *
 * ⚠ **A malformed pattern answers `true` (no problem) rather than throwing.**
 * `new RegExp` on a string from the network can throw, and a screen that white-
 * screens because a catalogue published a bad pattern is worse than one that
 * falls back to the server's own refusal — which still happens on submit. It is
 * NOT a silent pass in the dangerous direction: nothing is accepted that the
 * route would refuse, the officer just learns about it one round trip later.
 */
function matchesPublishedPattern(pattern: string, value: string): boolean {
  try {
    return new RegExp(pattern).test(value)
  } catch {
    return true
  }
}

/** One catalogue form's field-level problems, with the gate its submit button needs. */
export interface FieldProblems<Field extends string> {
  /** The problem per field, `null` where there is none. */
  readonly of: Readonly<Record<Field, string | null>>
  /**
   * `true` when any field THIS SUBMISSION WILL CARRY has one.
   *
   * ⚠ The submit button must be armed off THIS and not off presence alone —
   * `WardClassesPage`'s own note says why: a field the screen already knows is
   * malformed must not be sent, or the officer waits for a round trip to be told
   * what was on screen the whole time.
   *
   * ⚠ **"WILL CARRY" is load-bearing** — see {@link BoundsProblemOptions}. A
   * problem on a field that is not going to be sent must never disable the button,
   * because that field is not on screen to show the reason.
   */
  readonly any: boolean
}

/**
 * ★★ WAVE 8 (Task 3) REVIEW FINDING — THE FIELDS A SUBMISSION WILL NOT SEND.
 *
 * ══ THE DEFECT THIS REFUSES, WHICH THIS REPOSITORY HAS ALREADY LOGGED ══
 *
 * Eleven of these catalogue forms carry a *"Retire this … instead of superseding
 * it"* checkbox, and ticking it UNMOUNTS the establish-only fields — nothing is
 * being established, so there is nothing to describe. Their React state survives
 * the unmount, because it lives on the page and not in the field.
 *
 * So: type `0` into `WardClassesPage`'s Rank order, then tick Retire. The field
 * vanishes, `problems.of.rankOrder` is still set, `problems.any` is still `true`,
 * and — with `!problems.any` written as a TOP-LEVEL conjunct of `canSubmit` —
 * **Save goes disabled with no visible error anywhere on the form.** The officer is
 * stopped by a field they cannot see, over a value that is not going to be sent.
 *
 * `components/FieldError.tsx`'s own header records that failure verbatim from
 * Wave 5: *"`canSave` went false, and the officer got a disabled button and NO
 * message"*. The pre-Task-3 gate short-circuited it by construction —
 * `(retireInstead || (… && rankOrderProblem === null))` — and hoisting
 * `!problems.any` outside that parenthesis put it back on eleven screens at once.
 *
 * ══ WHY HERE AND NOT AT EACH CALL SITE ══
 *
 * Because the alternative is eleven copies of one conditional, and this is the file
 * that already knows which fields a form is asking about. A caller names the fields
 * it is NOT sending; their problem is reported as `null` and cannot reach `any`.
 * They stay present in `of`, so a screen keeps rendering `problems.of.<field>`
 * unconditionally and needs no type change.
 */
export interface BoundsProblemOptions<Field extends string> {
  /**
   * Fields this submission will not carry — on these screens, the establish-only
   * ones while "retire instead" is ticked.
   *
   * ⚠ It names what will not be **SENT**, not what is not RENDERED. On every
   * screen here those are the same set; if they ever diverge, the sent half is the
   * one that decides whether a refusal is even possible, so it is the one this
   * takes.
   *
   * ⚠ **`NoInfer` is load-bearing, not decoration.** Without it TypeScript infers
   * `Field` from THIS array in preference to the mapped `Record<Field, …>` above it,
   * so a caller passing three of its five field names narrowed `problems.of` to
   * those three and `problems.of.note` stopped existing — a real typecheck failure
   * on `WardClassesPage`, caught by the gate. `Field` must come from the labels map,
   * which is the form's whole field set; this parameter only ever names a subset of
   * it, and a name that is NOT in that set is still a typecheck error.
   */
  readonly notSubmitted?: readonly NoInfer<Field>[]
}

/**
 * Every published bound on one form, checked in one call.
 *
 * `sent` carries the values the form will actually submit (see this file's header
 * on why), and `labels` is the SAME map the fields are rendered from — one copy of
 * each label, not two.
 */
export function boundsProblems<Field extends string>(
  bounds: PublishedBounds<Field> | undefined,
  sent: Readonly<Record<Field, string>>,
  labels: Readonly<Record<Field, string>>,
  options: BoundsProblemOptions<Field> = {},
): FieldProblems<Field> {
  const notSubmitted = new Set<string>(options.notSubmitted ?? [])
  const of = {} as Record<Field, string | null>
  let any = false
  for (const field of Object.keys(labels) as Field[]) {
    // ⚠ `null`, not "skipped": a field that is not being sent cannot be in breach
    // of a rule that applies to what IS sent, and reporting it would disable a
    // button with nothing on screen to explain it.
    const problem = notSubmitted.has(field) ? null : boundsProblem(sent[field], labels[field], bounds?.[field])
    of[field] = problem
    if (problem !== null) any = true
  }
  return { of, any }
}
